import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Job from "../components/Job";
import SearchBar from "../components/SearchBar";
import { fetchJobs } from "../redux/features/job/jobSlice";

export default function JobFeed() {
  const dispatch = useDispatch();

  const { jobs, isLoading, isError } = useSelector((state) => state.job);
  const { sort, filter, search } = useSelector((state) => state.filter);

  useEffect(() => {
    dispatch(fetchJobs());
  }, [dispatch]);

  let content = null;
  // isLoading=true state
  if (isLoading) {
    content = <p className="error">Loading...</p>;
  }

  // isLoading=false & isError=true state
  if (!isLoading && isError) {
    content = <p className="error">There was an error occurred.</p>;
  }

  // isLoading=false & isError=false & jobs count = 0 state
  if (!isLoading && !isError && !filter && jobs?.length === 0) {
    content = <p className="error">No job found!</p>;
  }

  // isLoading=false & isError=false & jobs count > 0 state
  if (!isLoading && !isError && jobs?.length > 0) {
    // without any filter
    if (!filter) {
      content = jobs.map((job) => <Job key={job.id} job={job} />);
    }

    // filter by job type
    if (filter) {
      content = jobs
        .filter((job) => job.type === filter)
        .map((job) => <Job key={job.id} job={job} />);
    }

    // filter by search bar
    if (search) {
      content = jobs
        .filter((job) => job.title.toLowerCase().includes(search.toLowerCase()))
        .map((job) => <Job key={job.id} job={job} />);

      if (content.length === 0)
        content = <p className="error"> Sorry. Nothing found!</p>;
    }

    // filter by both job type & search
    if (filter && search) {
      content = jobs
        .filter((job) => job.type === filter)
        .filter((job) => job.title.toLowerCase().includes(search.toLowerCase()))
        .map((job) => <Job key={job.id} job={job} />);

      if (content.length === 0)
        content = <p className="error"> Sorry. Nothing found!</p>;
    }

    // filter and search state = ""
    if (!filter && !search) {
      content = jobs.map((job) => <Job key={job.id} job={job} />);
    }

    if (sort) {
      if (sort === "Salary (Low to High)") {
        content.sort(
          (a, b) => parseInt(a.props.job.salary) - parseInt(b.props.job.salary)
        );
      }

      if (sort === "Salary (High to Low)") {
        content.sort(
          (a, b) => parseInt(b.props.job.salary) - parseInt(a.props.job.salary)
        );
      }

      if (sort === "Date (Latest to Oldest)") {
        content.sort(
          (a, b) =>
            new Date(b.props.job.deadline) - new Date(a.props.job.deadline)
        );
      }

      if (sort === "Date (Oldest to Latest)") {
        content.sort(
          (a, b) =>
            new Date(a.props.job.deadline) - new Date(b.props.job.deadline)
        );
      }
    }
  }

  return (
    <div className="lg:pl-[14rem] mt-[5.8125rem]">
      <main className="max-w-3xl rounded-lg mx-auto relative z-20 p-10 xl:max-w-none bg-[#1E293B]">
        <div className="md:flex space-y-2 md:space-y-0 justify-between mb-10">
          <h1 className="lws-section-title">
            {!filter ? "All Available" : filter} Jobs
          </h1>

          <SearchBar />
        </div>
        <div className="jobs-list">{content}</div>
      </main>
    </div>
  );
}
